class PredictiveSearch extends SearchForm {
  constructor() {
    super();

    this.cachedResults = {};

    this.predictiveSearchResults =
      this.querySelector(
        '[data-predictive-search]'
      );

    this.allPredictiveSearchInstances =
      document.querySelectorAll(
        'predictive-search'
      );

    this.isOpen = false;

    this.abortController =
      new AbortController();

    this.searchTerm = '';

    this.setupEventListeners();

    this.toggleAttribute(
      'has-query',
      this.getQuery().length > 0
    );
  }


  setupEventListeners() {
    this.input.form.addEventListener(
      'submit',
      this.onFormSubmit.bind(this)
    );

    this.input.addEventListener(
      'focus',
      this.onFocus.bind(this)
    );

    this.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.addEventListener(
      'keyup',
      this.onKeyup.bind(this)
    );

    this.addEventListener(
      'keydown',
      this.onKeydown.bind(this)
    );


    this.querySelectorAll(
      '[data-wm-search-term]'
    ).forEach((trigger) => {

      trigger.addEventListener(
        'click',
        this.onQuickSearch.bind(this)
      );

    });
  }


  onQuickSearch(event) {
    event.preventDefault();
    event.stopPropagation();

    const searchTerm =
      event.currentTarget.dataset.wmSearchTerm;

    if (!searchTerm) {
      return;
    }

    this.input.value =
      searchTerm;

    this.toggleAttribute(
      'has-query',
      true
    );

    /*
      Direkt ausführen.
      Wir verlassen uns hier nicht nur auf
      einen künstlichen input-Event.
    */
    this.onChange();

    this.input.focus();
  }


  getQuery() {
    return this.input.value.trim();
  }


  normalizeSearchTerm(searchTerm) {
    return searchTerm
      .replace(
        /(\d+)\s*[x×*]\s*(\d+)/gi,
        '$1x$2'
      )
      .trim();
  }


  onChange() {
    super.onChange();

    const newSearchTerm =
      this.getQuery();

    this.toggleAttribute(
      'has-query',
      newSearchTerm.length > 0
    );


    if (
      !this.searchTerm ||
      !newSearchTerm.startsWith(
        this.searchTerm
      )
    ) {
      this.querySelector(
        '#predictive-search-results-groups-wrapper'
      )?.remove();
    }


    this.updateSearchForTerm(
      this.searchTerm,
      newSearchTerm
    );


    this.searchTerm =
      newSearchTerm;


    if (!this.searchTerm.length) {
      this.close(true);

      return;
    }


    this.getSearchResults(
      this.searchTerm
    );
  }


  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector(
        '[aria-selected="true"] a'
      )
    ) {
      event.preventDefault();
    }
  }


  onFormReset(event) {
    super.onFormReset(event);

    if (super.shouldResetForm()) {
      this.searchTerm = '';

      this.removeAttribute(
        'has-query'
      );

      this.abortController.abort();

      this.abortController =
        new AbortController();

      this.closeResults(true);
    }
  }


  onFocus() {
    const currentSearchTerm =
      this.getQuery();

    if (!currentSearchTerm.length) {
      return;
    }

    if (
      this.searchTerm !==
      currentSearchTerm
    ) {
      this.onChange();

    } else if (
      this.getAttribute('results') ===
      'true'
    ) {
      this.open();

    } else {
      this.getSearchResults(
        this.searchTerm
      );
    }
  }


  onFocusOut() {
    setTimeout(() => {

      if (
        !this.contains(
          document.activeElement
        )
      ) {
        this.close();
      }

    });
  }


  onKeyup(event) {
    if (!this.getQuery().length) {
      this.removeAttribute(
        'has-query'
      );

      this.close(true);
    }

    switch (event.code) {

      case 'ArrowUp':
        event.preventDefault();

        this.switchOption(
          'up'
        );

        break;


      case 'ArrowDown':
        event.preventDefault();

        this.switchOption(
          'down'
        );

        break;


      case 'Enter':
        this.selectOption();

        break;
    }
  }


  onKeydown(event) {
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }


  updateSearchForTerm(
    previousTerm,
    newTerm
  ) {
    if (!previousTerm) {
      return;
    }

    const searchForTextElement =
      this.querySelector(
        '[data-predictive-search-search-for-text]'
      );

    const currentButtonText =
      searchForTextElement?.innerText;

    if (!currentButtonText) {
      return;
    }

    searchForTextElement.innerText =
      currentButtonText.replace(
        previousTerm,
        newTerm
      );
  }


  switchOption(direction) {
    if (
      !this.getAttribute('open')
    ) {
      return;
    }

    const moveUp =
      direction === 'up';

    const selectedElement =
      this.querySelector(
        '[aria-selected="true"]'
      );


    const allVisibleElements =
      Array.from(
        this.querySelectorAll(
          'li[role="option"]'
        )
      ).filter(
        (element) =>
          element.offsetParent !== null
      );


    if (!allVisibleElements.length) {
      return;
    }


    let activeElementIndex = 0;


    if (
      moveUp &&
      !selectedElement
    ) {
      return;
    }


    const selectedElementIndex =
      selectedElement
        ? allVisibleElements.indexOf(
            selectedElement
          )
        : -1;


    if (
      !moveUp &&
      selectedElement
    ) {
      activeElementIndex =
        selectedElementIndex ===
        allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;

    } else if (moveUp) {

      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }


    if (selectedElement) {
      selectedElement.setAttribute(
        'aria-selected',
        'false'
      );
    }


    const activeElement =
      allVisibleElements[
        activeElementIndex
      ];


    activeElement.setAttribute(
      'aria-selected',
      'true'
    );


    this.input.setAttribute(
      'aria-activedescendant',
      activeElement.id
    );
  }


  selectOption() {
    const selectedOption =
      this.querySelector(
        '[aria-selected="true"] a'
      );

    if (selectedOption) {
      selectedOption.click();
    }
  }


  getSearchResults(searchTerm) {
    const requestTerm =
      this.normalizeSearchTerm(
        searchTerm
      );


    const queryKey =
      requestTerm
        .replace(/\s+/g, '-')
        .toLowerCase();


    this.setLiveRegionLoadingState();


    if (
      this.cachedResults[queryKey]
    ) {
      this.renderSearchResults(
        this.cachedResults[queryKey]
      );

      return;
    }


    this.abortController.abort();

    this.abortController =
      new AbortController();


    fetch(
      `${routes.predictive_search_url}?q=${encodeURIComponent(
        requestTerm
      )}&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=10&resources[limit_scope]=each`,
      {
        signal:
          this.abortController.signal,
      }
    )

      .then((response) => {

        if (!response.ok) {
          throw new Error(
            `Predictive Search ${response.status}`
          );
        }

        return response.text();
      })

      .then((text) => {

        const parsedDocument =
          new DOMParser().parseFromString(
            text,
            'text/html'
          );


        const section =
          parsedDocument.querySelector(
            '#shopify-section-predictive-search'
          );


        if (!section) {
          throw new Error(
            'Predictive Search section not found'
          );
        }


        const resultsMarkup =
          section.innerHTML;


        this.allPredictiveSearchInstances.forEach(
          (instance) => {

            instance.cachedResults[
              queryKey
            ] = resultsMarkup;

          }
        );


        this.renderSearchResults(
          resultsMarkup
        );
      })

      .catch((error) => {

        if (
          error?.name ===
          'AbortError'
        ) {
          return;
        }


        console.error(
          error
        );


        this.removeAttribute(
          'loading'
        );
      });
  }


  setLiveRegionLoadingState() {
    this.statusElement =
      this.statusElement ||
      this.querySelector(
        '.predictive-search-status'
      );


    this.loadingText =
      this.loadingText ||
      this.getAttribute(
        'data-loading-text'
      );


    this.setLiveRegionText(
      this.loadingText
    );


    this.setAttribute(
      'loading',
      true
    );
  }


  setLiveRegionText(statusText) {
    if (!this.statusElement) {
      return;
    }


    this.statusElement.setAttribute(
      'aria-hidden',
      'false'
    );


    this.statusElement.textContent =
      statusText || '';


    setTimeout(() => {

      this.statusElement.setAttribute(
        'aria-hidden',
        'true'
      );

    }, 1000);
  }


  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML =
      resultsMarkup;


    this.setAttribute(
      'results',
      true
    );


    /*
      WICHTIG:
      Jetzt ist das tatsächliche Shopify-DOM vorhanden.
      Erst JETZT erzwingen wir das Mobile-Layout.
    */
    this.applyMobileProductLayout();


    this.setLiveRegionResults();

    this.open();
  }


  applyMobileProductLayout() {
    /*
      Nur Header Search.
    */
    if (
      !this.closest('.header__search')
    ) {
      return;
    }


    /*
      Desktop:
      keinerlei Inline-Styling.
    */
    if (
      !window.matchMedia(
        '(max-width: 749px)'
      ).matches
    ) {
      return;
    }


    const cards =
      this.predictiveSearchResults.querySelectorAll(
        '.wmps4__product'
      );


    cards.forEach((card) => {

      const media =
        card.querySelector(
          ':scope > .wmps4__media'
        );

      const copy =
        card.querySelector(
          ':scope > .wmps4__copy'
        );


      if (
        !media ||
        !copy
      ) {
        return;
      }


      const title =
        copy.querySelector(
          '.wmps4__title'
        );


      const price =
        copy.querySelector(
          '.wmps4__price'
        );


      const set =
        (
          element,
          property,
          value
        ) => {

          if (!element) {
            return;
          }

          element.style.setProperty(
            property,
            value,
            'important'
          );
        };


      /*
        PRODUKTKARTE
      */

      set(
        card,
        'display',
        'grid'
      );

      set(
        card,
        'grid-template-columns',
        '108px minmax(0, 1fr)'
      );

      set(
        card,
        'grid-template-rows',
        'auto'
      );

      set(
        card,
        'column-gap',
        '14px'
      );

      set(
        card,
        'row-gap',
        '0'
      );

      set(
        card,
        'align-items',
        'center'
      );

      set(
        card,
        'width',
        '100%'
      );

      set(
        card,
        'min-width',
        '0'
      );

      set(
        card,
        'margin',
        '0'
      );

      set(
        card,
        'padding',
        '10px 0'
      );


      /*
        BILD – SPALTE 1
      */

      set(
        media,
        'display',
        'block'
      );

      set(
        media,
        'grid-column',
        '1'
      );

      set(
        media,
        'grid-row',
        '1'
      );

      set(
        media,
        'width',
        '108px'
      );

      set(
        media,
        'min-width',
        '108px'
      );

      set(
        media,
        'max-width',
        '108px'
      );

      set(
        media,
        'height',
        '84px'
      );

      set(
        media,
        'min-height',
        '84px'
      );

      set(
        media,
        'max-height',
        '84px'
      );

      set(
        media,
        'margin',
        '0'
      );

      set(
        media,
        'padding',
        '0'
      );


      /*
        TEXT + PREIS – SPALTE 2
      */

      set(
        copy,
        'display',
        'flex'
      );

      set(
        copy,
        'grid-column',
        '2'
      );

      set(
        copy,
        'grid-row',
        '1'
      );

      set(
        copy,
        'flex-direction',
        'column'
      );

      set(
        copy,
        'align-items',
        'flex-start'
      );

      set(
        copy,
        'justify-content',
        'center'
      );

      set(
        copy,
        'width',
        '100%'
      );

      set(
        copy,
        'min-width',
        '0'
      );

      set(
        copy,
        'margin',
        '0'
      );

      set(
        copy,
        'padding',
        '0'
      );

      set(
        copy,
        'overflow',
        'visible'
      );


      /*
        TITEL:
        Keine künstliche 2-Zeilen-Abschneidung mehr.
      */

      set(
        title,
        'display',
        'block'
      );

      set(
        title,
        'width',
        '100%'
      );

      set(
        title,
        'min-height',
        '0'
      );

      set(
        title,
        'margin',
        '0'
      );

      set(
        title,
        'padding',
        '0'
      );

      set(
        title,
        'overflow',
        'visible'
      );

      set(
        title,
        '-webkit-line-clamp',
        'unset'
      );

      set(
        title,
        'white-space',
        'normal'
      );

      set(
        title,
        'font-size',
        '14px'
      );

      set(
        title,
        'line-height',
        '1.35'
      );


      /*
        PREIS DIREKT DARUNTER
      */

      set(
        price,
        'display',
        'block'
      );

      set(
        price,
        'width',
        '100%'
      );

      set(
        price,
        'margin',
        '7px 0 0'
      );

      set(
        price,
        'padding',
        '0'
      );

      set(
        price,
        'text-align',
        'left'
      );
    });
  }


  setLiveRegionResults() {
    this.removeAttribute(
      'loading'
    );


    const liveRegionValue =
      this.querySelector(
        '[data-predictive-search-live-region-count-value]'
      );


    if (liveRegionValue) {
      this.setLiveRegionText(
        liveRegionValue.textContent
      );
    }
  }


  getResultsMaxHeight() {
    const headerBottom =
      document
        .querySelector(
          '.section-header'
        )
        ?.getBoundingClientRect()
        .bottom || 0;


    this.resultsMaxHeight =
      Math.max(
        240,
        window.innerHeight -
        headerBottom
      );


    return this.resultsMaxHeight;
  }


  open() {
    this.applyMobileProductLayout();


    this.predictiveSearchResults.style.maxHeight =
      `${this.getResultsMaxHeight()}px`;


    this.setAttribute(
      'open',
      true
    );


    this.input.setAttribute(
      'aria-expanded',
      'true'
    );


    this.isOpen =
      true;
  }


  close(clearSearchTerm = false) {
    this.closeResults(
      clearSearchTerm
    );

    this.isOpen =
      false;
  }


  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';

      this.searchTerm = '';

      this.removeAttribute(
        'results'
      );

      this.removeAttribute(
        'has-query'
      );
    }


    const selected =
      this.querySelector(
        '[aria-selected="true"]'
      );


    if (selected) {
      selected.setAttribute(
        'aria-selected',
        'false'
      );
    }


    this.input.setAttribute(
      'aria-activedescendant',
      ''
    );


    this.removeAttribute(
      'loading'
    );


    this.removeAttribute(
      'open'
    );


    this.input.setAttribute(
      'aria-expanded',
      'false'
    );


    this.resultsMaxHeight =
      false;


    this.predictiveSearchResults.removeAttribute(
      'style'
    );
  }


  /*
    Wird vom echten DetailsModal aufgerufen.
  */
  resetForModalClose() {
    this.abortController.abort();

    this.abortController =
      new AbortController();


    this.searchTerm = '';

    this.closeResults(true);
  }
}


customElements.define(
  'predictive-search',
  PredictiveSearch
);